/**
 * Get Value inside Record based on path, Otherwise return default value like lodash.get!
 */
export default (function (obj, path, defaultValue) {
  var result = String.prototype.split.call(path, /[,[\].]+?/).filter(Boolean).reduce(function (res, key) {
    return res !== null && res !== undefined ? res[key] : res;
  }, obj);
  return result === undefined || result === obj ? defaultValue : result;
});
//# sourceMappingURL=get.js.map